import React from 'react';
import { ModelDetails } from '../configuration/model-description';
import { Link } from 'react-router-dom';

function ModelLinks(props: { onlyModels?: string[], exceptModels?: string[], maxCount?: number }) {
  return (
    <ul>
      {Object.entries(ModelDetails)
        .sort(([, modelDetailsA], [, modelDetailsB]) => modelDetailsA.seoRank - modelDetailsB.seoRank)
        .map(([model, modelDetails]) => model)
        .filter(x => !props.onlyModels || props.onlyModels.includes(x))
        .filter(x => !props.exceptModels || !props.exceptModels.includes(x))
        .slice(0, props.maxCount)
        .map((model, i) => (
        <li>
          <Link
            className="link-secondary"
            to={`/m/levis-${model}/`}
            title={`Levi’s ${model} ${ModelDetails[Number(model)].fitName} - купити оригінальні джинси`}
          >
              <strong>Levi’s {model} {ModelDetails[Number(model)].fitName}</strong> - {ModelDetails[Number(model)].fitDescription[0].toLowerCase()}{ModelDetails[Number(model)].fitDescription.slice(1)}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default ModelLinks;
